<template>
  <base-dialog
    :title="'house.param.floors.title' | i18n"
    :subtitle="'house.param.floors.subtitle' | i18n"
    :description="'house.param.floors.description' | i18n">

    <div class="container-fluid" style="padding: 0;">
      <div class="row">
        <div class="col-4">
          <img src="../../assets/param/house_floors.png" />
          <img src="../../assets/param/house_floor_height.png" />
        </div>

        <div class="col-8">
          <div>
            Yläkerros YK sisältyy <tickbox style="float: right;" v-model="upstairsIncluded" />
            <small class="form-text text-muted">Kerroskorkeus (1,90 - 4,50 m)</small>
            <input-number v-model="upstairsHeight" :decimals="1" :min="1.9" :max="4.5" />
          </div>
          <hr />
            Asuinkerros AK sisältyy  <tickbox style="float: right;" :value="true" :disabled="true" />
            <small class="form-text text-muted">Kerroskorkeus (1,90 - 4,50 m)</small>
            <input-number v-model="livingFloorHeight" :decimals="1" :min="1.9" :max="4.5" />
          <hr />
          <div>
            Kellari K sisältyy  <tickbox style="float: right;" v-model="basementIncluded" />
            <small class="form-text text-muted">Kerroskorkeus (1,90 - 3,50 m)</small>
            <input-number v-model="basementHeight" :decimals="1" :min="1.9" :max="3.5" />
          </div>
          <hr />
          <div>
            Perustus sisältyy <tickbox style="float: right;" :value="true" :disabled="true" />
            <small class="form-text text-muted">Kerroskorkeus (0,40 - 3,00 m)</small>
            <input-number v-model="foundationHeight" :decimals="1" :min="0.4" :max="3.0" />
          </div>
        </div>
      </div>
    </div>
  </base-dialog>
</template>


<script>
  import BaseDialog from "./BaseDialog"

  export default {
    computed: {
      upstairsIncluded: {
        get() {
          return this.$store.state.houseParams.upstairsIncluded
        },
        set(upstairsIncluded) {
          this.$store.commit('houseParams/SET_UPSTAIRS_INCLUDED', upstairsIncluded)
        }
      },
      upstairsHeight: {
        get() {
          return this.$store.state.houseParams.upstairsHeight
        },
        set(upstairsHeight) {
          this.$store.commit('houseParams/SET_UPSTAIRS_HEIGHT', upstairsHeight)
        }
      },
      livingFloorHeight: {
        get() {
          return this.$store.state.houseParams.livingFloorHeight
        },
        set(livingFloorHeight) {
          this.$store.commit('houseParams/SET_LIVING_FLOOR_HEIGHT', livingFloorHeight)
        }
      },
      basementIncluded: {
        get() {
          return this.$store.state.houseParams.basementIncluded
        },
        set(basementIncluded) {
          this.$store.commit('houseParams/SET_BASEMENT_INCLUDED', basementIncluded)
        }
      },
      basementHeight: {
        get() {
          return this.$store.state.houseParams.basementHeight
        },
        set(basementHeight) {
          this.$store.commit('houseParams/SET_BASEMENT_HEIGHT', basementHeight)
        }
      },
      foundationHeight: {
        get() {
          return this.$store.state.houseParams.foundationHeight
        },
        set(foundationHeight) {
          this.$store.commit('houseParams/SET_FOUNDATION_HEIGHT', foundationHeight)
        }
      }
    },

    created() {
      if(this.upstairsIncluded == null) {
        this.upstairsIncluded = false
      }
      if(this.upstairsHeight == null) {
        this.upstairsHeight = 2.6
      }
      if(this.livingFloorHeight == null) {
        this.livingFloorHeight = 2.9
      }
      if(this.basementIncluded == null) {
        this.basementIncluded = false
      }
      if(this.basementHeight == null) {
        this.basementHeight = 2.6
      }
      if(this.foundationHeight == null) {
        this.foundationHeight = 0.5
      }
    },

    components: {
      BaseDialog
    }
  }
</script>

<style scoped>
  img {
    width: 100%;
  }
  tickbox {
    float: right;
  }
</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseFloorsDialog.vue